module.exports = __webpack_public_path__ + "img/Australia.ba093f23.svg";